import UsageTracker from '../../../utils/UsageTracker';
import { useHistory } from 'quartz-routing/react-router';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useSavedLearningInterest, useWizardResults } from '../../wizard';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useSearchFeedback } from '../../search';
import Raven from 'raven-js';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { useSearchState } from '../../search/searchStore';
import { isLessonRecommendation } from '../recommendationsUtils';
import { CardsSection } from 'academy-common-lib/features/cardsSection/components/CardsSection';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import getLang from 'academy-common-lib/utils/getLang';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TitleAction = ({
  resultsCount,
  resultsUrl
}) => {
  const handleViewResults = () => {
    UsageTracker.track('interaction', {
      action: 'interest-recommendations-view-results-clicked'
    });
  };
  return resultsCount > 4 ? /*#__PURE__*/_jsx(RouterLink, {
    onClick: handleViewResults,
    to: resultsUrl,
    underline: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.wizard.modal.stepfinal.resultslink",
      options: {
        resultsCount
      }
    })
  }) : null;
};
const SubTitle = ({
  selectedCategory,
  selectedCategoryGroup,
  selectedTool,
  selectedToolsGroup
}) => {
  const history = useHistory();
  const handleSetLearningInterest = () => {
    UsageTracker.track('interaction', {
      action: 'interest-recommendations-set-learning-interest-clicked'
    });
    history.push('/wizard');
  };
  let message = null;
  if (selectedCategory) message = `learningCenter.topFilters.cat.${selectedCategory}`;else if (selectedCategoryGroup) message = `learningCenter.filtersGroups.${selectedCategoryGroup}`;else if (selectedTool) message = `learningCenter.topFilters.tools.${selectedTool}`;else if (selectedToolsGroup) message = `learningCenter.filtersGroups.${selectedToolsGroup}`;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: message ? `learningCenter.tracks.subheaders.learningInterest` : `learningCenter.tracks.subheaders.learningInterestGeneric`,
    options: {
      learningInterest: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "learning-interest-label",
        message: message || ''
      }),
      setInterestLink: /*#__PURE__*/_jsx(RouterLink, {
        "data-test-id": "preference-change-button",
        onClick: handleSetLearningInterest,
        to: "/wizard",
        underline: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.fieldLink.edit"
        })
      })
    }
  });
};
const useRecommendationsBasedOnInterestContent = maxCards => {
  const learningInterest = useSavedLearningInterest();
  const {
    searchResults,
    resultsCount,
    selectedCategoryGroup,
    selectedToolsGroup,
    selectedCategory,
    selectedTool,
    resultsUrl,
    correlationId,
    error,
    isRequesting
  } = useWizardResults({
    learningInterest,
    pageLength: maxCards
  });

  // retrieves hydrated card models for the elements to render
  const {
    cardModels,
    cardModelsError,
    cardModelsLoading
  } = useLearningContentCardModels({
    items: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(({
      contentType,
      id,
      language,
      resultMLOptionId
    }) => {
      return {
        id,
        type: contentType === 'TEMPLATE' || contentType === 'EBOOK' ? 'LESSON' : contentType,
        language: language || getLang(),
        resultMLOptionId
      };
    })) || [],
    skip: !(searchResults !== null && searchResults !== void 0 && searchResults.length)
  });
  return {
    content: cardModels,
    loading: isRequesting || cardModelsLoading,
    error: error || cardModelsError,
    correlationId,
    resultsCount,
    selectedCategoryGroup,
    selectedToolsGroup,
    selectedCategory,
    selectedTool,
    resultsUrl
  };
};
export const RecommendationsBasedOnInterest = ({
  containerError,
  containerLoading,
  onRenderEmpty
}) => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const {
    setLastClickedSearchResultItem
  } = useSearchState();
  const [sendSearchFeedback] = useSearchFeedback();
  const [maxCards, setMaxCards] = useState();
  const {
    content,
    loading,
    error,
    correlationId,
    resultsCount,
    selectedCategory,
    selectedCategoryGroup,
    selectedTool,
    selectedToolsGroup,
    resultsUrl
  } = useRecommendationsBasedOnInterestContent(maxCards);
  const showLoadingState = containerLoading || loading;
  const showErrorState = error || containerError;
  const handleOnItemClick = ({
    id,
    type,
    language,
    resultMLOptionId,
    name
  }, position) => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-card-click',
      cardNumber: position + 1,
      contentId: id,
      contentType: type,
      name,
      recommendedBecauseTrackId: type === 'TRACK' && id,
      recommendedBecauseLessonId: isLessonRecommendation(type) && id,
      recommendationType: 'learning-interest'
    });
    setLastClickedSearchResultItem({
      item: {
        id,
        type: type,
        language: language || undefined
      },
      position
    });
    if (correlationId) sendSearchFeedback({
      variables: {
        correlationId,
        contentContainerType: type,
        resultMLOptionId
      }
    }).catch(Raven.captureException.bind(Raven));
  };
  return /*#__PURE__*/_jsx(CardsSection, {
    appearsIn: "recommendations-interest",
    cardsContainerProps: {
      paddingBlockEnd: '0'
    },
    content: content,
    description: /*#__PURE__*/_jsx(SubTitle, {
      selectedCategory: selectedCategory,
      selectedCategoryGroup: selectedCategoryGroup,
      selectedTool: selectedTool,
      selectedToolsGroup: selectedToolsGroup
    }),
    direction: isTablet ? 'column' : 'row',
    error: showErrorState,
    errorMarker: "HOMEPAGE_RECOMMENDATIONS_ERROR",
    flush: true,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.tracks.headers.recommended"
    }),
    headerActions: !isMobile && /*#__PURE__*/_jsx(TitleAction, {
      resultsCount: resultsCount,
      resultsUrl: resultsUrl
    }),
    isLoading: showLoadingState,
    maxSkeletonListLength: isTablet ? 3 : maxCards,
    navMarker: !showLoadingState && !showErrorState ? 'HOMEPAGE_RECOMMENDATIONS_LOADED' : undefined,
    onItemClick: handleOnItemClick,
    onRenderEmpty: onRenderEmpty,
    setMaxCards: setMaxCards,
    size: isTablet ? 'small' : 'large'
  });
};
export default RecommendationsBasedOnInterest;